/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1HIcon20Light = forwardRef('ArrowDim1HIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "m17.791 10.001-.029.03-3.617 3.618a.5.5 0 1 0 .707.708l3.617-3.618a1.75 1.75 0 0 0 0-2.475l-3.617-3.618a.5.5 0 1 0-.707.708l3.617 3.617.029.03H2.209l.028-.03 3.616-3.616a.5.5 0 0 0-.707-.707L1.53 8.264a1.75 1.75 0 0 0 0 2.475l3.616 3.616a.5.5 0 1 0 .707-.707l-3.616-3.616A.773.773 0 0 1 2.208 10h15.583Z" })));
});
